import BackButton from '../components/BackButton';
import { useEffect, useState } from 'react';
import api from '../api';
import { useApp } from '../App';
import Loading from '../components/Loading';
import { useI18n } from '../i18n/index.jsx';

export default function AdminPartnerContracts() {
  const { isAdmin } = useApp();
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => { if (isAdmin) load(); }, [isAdmin]);

  async function load() {
    setLoading(true);
    try {
      const { data } = await api.get('/partner-contracts/admin/list?status=submitted');
      setItems(data || []);
    } catch (e) {
      setMsg(e.userMessage || e.response?.data?.detail || 'Ошибка');
    } finally {
      setLoading(false);
    }
  }

  async function verify(id, status) {
    try {
      await api.post(`/partner-contracts/admin/${id}/verify?status=${status}`);
      setMsg(status === 'approved' ? '✅ Одобрено' : '❌ Отклонено');
      load();
    } catch (e) {
      setMsg(e.userMessage || e.response?.data?.detail || 'Ошибка');
    }
  }

  if (!isAdmin) return <div className="page"><BackButton /><h2>⛔ Доступ запрещён</h2></div>;
  if (loading) return <Loading />;

  return (
    <div className="page"><BackButton />
      <h1>✅ Верификация договоров</h1>
      {msg && <div className="message">{msg}</div>}
      {items.length === 0 ? (
        <div className="empty">Нет договоров на проверке</div>
      ) : (
        <div className="list">
          {items.map(c => (
            <div key={c.id} className="list-item" style={{ alignItems: 'flex-start' }}>
              <div className="list-main">
                <div className="list-title">#{c.id} • {c.contract_type}</div>
                {c.subject && <div className="list-sub">{c.subject}</div>}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <a className="btn btn-small" href={`${api.defaults.baseURL}/partner-contracts/${c.id}/pdf`} target="_blank" rel="noreferrer">PDF</a>
                <button className="btn btn-small" onClick={() => verify(c.id, 'approved')}>✅</button>
                <button className="btn btn-small" style={{ background: 'rgba(239,68,68,0.3)' }} onClick={() => verify(c.id, 'rejected')}>❌</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
